import { render, staticRenderFns } from "./DocumentCategoryModal.vue?vue&type=template&id=79e2dc27&scoped=true&"
import script from "./DocumentCategoryModal.vue?vue&type=script&lang=js&"
export * from "./DocumentCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCategoryModal.vue?vue&type=style&index=0&id=79e2dc27&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e2dc27",
  null
  
)

export default component.exports